var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L8 8",
    stroke: "#65A30D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5478 17.904C15.2353 18.2166 14.8114 18.3923 14.3694 18.3924C13.9273 18.3925 13.5034 18.2169 13.1907 17.9044C12.8781 17.5919 12.7024 17.168 12.7024 16.726C12.7023 16.2839 12.8778 15.86 13.1903 15.5473L11.7178 17.0207C11.4052 17.3333 10.9812 17.5089 10.5391 17.5089C10.097 17.5089 9.67295 17.3333 9.36032 17.0207C9.0477 16.708 8.87207 16.284 8.87207 15.8419C8.87207 15.3998 9.0477 14.9758 9.36032 14.6632L14.6637 9.35984C14.9763 9.04721 15.4003 8.87158 15.8424 8.87158C16.2845 8.87158 16.7085 9.04721 17.0212 9.35984C17.3338 9.67246 17.5094 10.0965 17.5094 10.5386C17.5094 10.9807 17.3338 11.4047 17.0212 11.7173L15.5478 13.1898C15.8604 12.8773 16.2844 12.7018 16.7265 12.7019C17.1685 12.702 17.5924 12.8776 17.9049 13.1903C18.2174 13.5029 18.3929 13.9268 18.3929 14.3689C18.3928 14.8109 18.2171 15.2348 17.9045 15.5473L15.5478 17.904Z",
    stroke: "#65A30D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 17.9167L16.75 16.75",
    stroke: "#65A30D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24967 3.24992L2.08301 2.08325",
    stroke: "#65A30D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33663 10.64C5.02401 10.9526 4.6 11.1282 4.15788 11.1282C3.71576 11.1282 3.29176 10.9526 2.97913 10.64C2.66651 10.3273 2.49088 9.90333 2.49088 9.46121C2.49088 9.0191 2.66651 8.59509 2.97913 8.28246L4.45246 6.80996C4.29767 6.96471 4.11391 7.08744 3.91168 7.17117C3.70945 7.25489 3.49271 7.29796 3.27384 7.29792C2.8318 7.29785 2.40789 7.12217 2.09538 6.80955C1.94064 6.65475 1.8179 6.47099 1.73418 6.26876C1.65046 6.06654 1.60738 5.8498 1.60742 5.63092C1.6075 5.18888 1.78317 4.76498 2.0958 4.45246L4.45246 2.0958C4.76498 1.78317 5.18888 1.6075 5.63092 1.60742C5.8498 1.60738 6.06654 1.65046 6.26876 1.73418C6.47099 1.8179 6.65475 1.94064 6.80955 2.09538C6.96434 2.25012 7.08715 2.43384 7.17094 2.63604C7.25474 2.83824 7.29789 3.05496 7.29792 3.27384C7.29796 3.49271 7.25489 3.70945 7.17117 3.91168C7.08744 4.11391 6.96471 4.29767 6.80996 4.45246L8.28246 2.97913C8.59509 2.66651 9.0191 2.49088 9.46121 2.49088C9.90333 2.49088 10.3273 2.66651 10.64 2.97913C10.9526 3.29176 11.1282 3.71576 11.1282 4.15788C11.1282 4.6 10.9526 5.02401 10.64 5.33663L5.33663 10.64Z",
    stroke: "#65A30D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth2);
export default __webpack_public_path__ + "static/media/Health2.c569e88b88bc5fc1a8f8a85b43c78db3.svg";
export { ForwardRef as ReactComponent };